// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607231148/js/" + chunkId + "." + {"44":"d0601d93","225":"fa99bb44","481":"c35138dd","486":"2473510c","770":"d13173f2"}[chunkId] + ".0.1670969670684802.chunk.js";
};